import React from 'react'
import { Field, Form, Formik } from 'formik'
import { TextField, Button } from '@material-ui/core'
import AuthService from '../services/AuthService'
import "../styles/AdminReset.css"

function AdminReset() {
    const iniVal = {
        pass: '',
        cnfpass: ''
    }
    const handleReset = (values) => {
        if(values.pass === values.cnfpass){
            AuthService.resetPassword(values.pass).then(res => {
                alert(res.msg);
            })
        }
        else{
            alert("Both passwords should be same");
        }
    }
    return (
        <div className="resetMain">
            <div className="resetContainer">
                <h4>Reset Password</h4>
                <Formik initialValues={iniVal} onSubmit={handleReset}>
                    {
                        () => (
                            <Form>
                                <div style={{display:'flex', flexDirection:'column', gap:'20px'}}>
                                    <Field name="pass" as={TextField}  label="Password" variant="outlined" type="password" />
                                    <Field name="cnfpass" as={TextField}  label=" Password" variant="outlined" type="password"/>
                                    <Button variant="contained" color="primary" type="submit">Reset Password</Button>
                                </div>
                            </Form>
                        )
                    }
                </Formik>
            </div>
        </div>
    )
}

export default AdminReset
